<script lang="ts">
  import { CloudUpload, FileX2 } from '@lucide/svelte'
  import EmptyState from '../../../../components/empty-state/EmptyState.svelte'
  import GroupPane from '../../../../components/group-pane/GroupPane.svelte'
  import { getGroupId } from '../../../../helpers/group'
  import i18n from '../../../../i18n'
  import useGroupsQueries from '../../hooks/useGroupsQueries'
  import useUploadedFilesQueries from '../../hooks/useUploadedFilesQueries'
  import { supportedFileExtensionsHtmlAccept } from '../../../../constants/files'

  const { useGroups } = useGroupsQueries()
  const groupsQuery = useGroups()

  let input: HTMLInputElement

  const { uploadFileMutation } = useUploadedFilesQueries()

  function handleClick() {
    input.click()
  }
</script>

{#if groupsQuery.data && groupsQuery.data.length > 0}
  <div class="files-container">
    {#each groupsQuery.data || [] as group (group.uuid)}
      <GroupPane id={getGroupId(group)} />
    {/each}
  </div>
{:else}
  <EmptyState
    buttonIcon={CloudUpload}
    buttonLabel={$i18n.t('project.leftBar.files.emptyState.buttonLabel')}
    icon={FileX2}
    onButtonClick={() => handleClick()}
    subtitle={$i18n.t('project.leftBar.files.emptyState.subtitle')}
    title={$i18n.t('project.leftBar.files.emptyState.title')}
  />

  <input
    bind:this={input}
    class="upload-file-input"
    accept={supportedFileExtensionsHtmlAccept}
    multiple
    onchange={e =>
      uploadFileMutation.mutate((e.target as HTMLInputElement).files)}
    type="file"
  />
{/if}

<style lang="scss">
  .files-container {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;
  }

  .upload-file-input {
    display: none;
  }
</style>
